import type { ButtonConfig } from '../../declare'
import { useMemo, useContext } from 'react'
import { EasyIcon, EasyModal, FormPage, FormPropsContext, ListTableContext } from 'src/components'
import { $consts } from 'src/plugins'
import { getSingleRule } from 'src/utils/common'
import { get, set } from 'lodash'

type Props = {
  config: ButtonConfig
}

const ListModalBtn = (props: Props) => {
  const formProps = useContext(FormPropsContext)
  const table = useContext(ListTableContext)

  const fromListRow = useMemo(() => {
    const fromWhere = formProps.formData?.fromWhere
    return (
      fromWhere?.pageType === $consts['TABLE/FORM_TYPE_LIST_PAGE']
      && fromWhere?.locateType === $consts['TABLE/BTN_LOCATE_ROW']
      && fromWhere?.data
    )
  }, [formProps.formData?.fromWhere])

  const formData = useMemo(() => {
    const data = {}

    if (fromListRow) {
      set(data, 'fromWhere', {
        pageType: $consts['TABLE/FORM_TYPE_LIST_PAGE'],
        locateType: $consts['TABLE/BTN_LOCATE_ROW'],
        data: Object.assign({}, fromListRow)
      })
    }

    const { __RECORD__: record, CUSTOM_PARAMS } = props.config
    if (CUSTOM_PARAMS && record.ID) {
      const fromData = get(data, 'fromWhere.data')
      set(data, 'fromWhere', {
        pageType: $consts['TABLE/FORM_TYPE_LIST_PAGE'],
        locateType: $consts['TABLE/BTN_LOCATE_ROW'],
        data: Object.assign({}, fromData, { [CUSTOM_PARAMS]: record.ID })
      })
      set(data, 'filterGroup', {
        Rules: [getSingleRule(CUSTOM_PARAMS, 1, record.ID)]
      })
    }

    return data
  }, [fromListRow, props.config.__RECORD__, props.config.CUSTOM_PARAMS])

  const { __RENDER_SLOT__: renderSlot, LABEL, ICON, FORM_CODE, WIDTH } = props.config
  return (
    <EasyModal
      modal={{
        title: FORM_CODE,
        width: WIDTH || '100%',
        styles: { body: { margin: '-12px -18px' } },
        afterClose: () => table?.reload()
      }}
      slot={
        renderSlot?.(props.config) ?? (
          <span>
            <EasyIcon type={ICON} defaultIcon='TableOutlined' className='fz-16' />
            <span title={LABEL} className='pd-l4'>{LABEL}</span>
          </span>
        )
      }
    >
      <FormPage formCode={FORM_CODE} formData={formData} />
    </EasyModal>
  )
}

export default ListModalBtn